<script lang="ts">
    import { isEditActive } from "$src/application/main/mainTemplateStore";
    import {
      projectDraft,
      projectOriginal,
    } from "$src/application/projects/stores/projectStore";
    import { formatCurrency } from "$src/presentation/core/currencyUtils";
    import AnchorLink from "../anchor-link.svelte";
    import PriceMarginAmount from "./price-margin-amount.svelte";
  
    export let marginVisible: boolean;
  </script>
  
  <div class="hidden md:flex"></div>
  <div
    class="text-md flex flex-row-reverse md:flex-row gap-4 font-semibold bg-muted text-foreground p-2 border-4 rounded-t-2xl"
  >
    {#if marginVisible}
      {#if $isEditActive && $projectDraft}
        <PriceMarginAmount
          class="py-0"
          value={$projectDraft.prices.totalMarginExVat}
          currency={$projectDraft.prices.currency}
        />
      {:else}
        <PriceMarginAmount
          class="py-0"
          value={$projectOriginal.prices.totalMarginExVat}
          currency={$projectOriginal.prices.currency}
        />
      {/if}
    {/if}
  
    {#if $isEditActive && $projectDraft}
      <AnchorLink
        href="#priceTable"
        text={formatCurrency(
          $projectDraft.prices.totalAmountIncVat,
          $projectDraft.prices.currency
        )}
      />
    {:else}
      <AnchorLink
        href="#priceTable"
        text={formatCurrency(
          $projectOriginal.prices.totalAmountIncVat,
          $projectOriginal.prices.currency
        )}
      />
    {/if}
  </div>
  <div class="md:hidden"></div>
  